export default "__VITE_ASSET__CJaFvCPo__"